import axios from 'src/api/Api';
import { ERROR_BOUNDARY_STATUS } from 'src/constants/appConstants';
import { logErrorToConsole, getBrowserName } from './util';
import { encryptData } from './encryptionUtils';
// Utility to log UI errors to backend
export async function logUiErrorToBackend(error, options = {}) {
  console.log(error);
  const errorMessageLower = error?.message?.toLowerCase() || '';
  const errorNameLower = error?.name?.toLowerCase() || '';
  const errorCodeLower = error?.code || '';

  if (!ERROR_BOUNDARY_STATUS ||
    errorMessageLower === 'request cancelled' ||
    errorCodeLower === 'err_canceled' ||
    errorNameLower === 'cancelederror' ||
    errorNameLower === 'aborterror' ||
    // errorNameLower === 'chunkloaderror' ||
    errorMessageLower.includes('canceled') ||
    errorMessageLower.includes('cancelled') ||
    errorMessageLower.includes('aborted') ||
    errorMessageLower.includes('request aborted')
    // errorMessageLower.includes('Loading chunk')
  ) {    
    return;
  }
  
  // Check if this is a ChunkLoadError
  const isChunkLoadError = errorMessageLower.includes('loading chunk') || errorNameLower === 'chunkloaderror';
  
  // Encrypt requestPayload if it exists
  const encryptedPayload = options.requestPayload 
    ? encryptData(options.requestPayload) 
    : '';
  
  // Get page name from localStorage (set by useDynatracePageName hook)
  const dynatracePageName = localStorage.getItem('pageName') || '';
  const currentPage = dynatracePageName || window.location.pathname;
  
  // Extract error type properly
  let errorType = '';
  if (error?.name) {
    errorType = error.name;
  } else if (error?.constructor?.name && error.constructor.name !== 'Object') {
    errorType = error.constructor.name;
  } else if (typeof error === 'string') {
    errorType = 'Error';
  } else if (error?.response) {
    errorType = 'AxiosError';
  } else {
    errorType = 'UnknownError';
  }
  
  // Build comprehensive error message with API response details
  let errorMessage = '';
  
  // If error has response (API error), extract status code and message
  if (error?.response) {
    const statusCode = error.response.status || error.response.data?.statusCode || '';
    const statusMessage = error.response.data?.statusMessage || 
                         error.response.data?.statusDescription || 
                         error.response.statusText || '';
    const originalMessage = error.message || '';
    
    // Combine status code and message
    if (statusCode && statusMessage) {
      errorMessage = `[${statusCode}] ${statusMessage}`;
      if (originalMessage && !originalMessage.includes(statusCode)) {
        errorMessage += ` - ${originalMessage}`;
      }
    } else if (statusCode) {
      errorMessage = `[${statusCode}] ${originalMessage || 'API Error'}`;
    } else if (statusMessage) {
      errorMessage = statusMessage;
    } else {
      errorMessage = originalMessage || error.toString();
    }
  } else {
    // For non-API errors, use standard error message
    errorMessage = error?.message || error?.toString() || 'Unknown error';
  }
  
  const errorDetails = {
    timestamp: new Date().toLocaleString(),
    sessionId: localStorage.getItem('authToken'),
    userId: localStorage.getItem('NetworkId') || '',
    page: isChunkLoadError ? currentPage+"-Reloaded" : currentPage,
    apiEndPoint: options.apiEndPoint || '',
    browser: getBrowserName(),
    device: /Mobi|Android/i.test(navigator.userAgent) ? 'Mobile' : 'Desktop',
    errorType: errorType,
    errorMessage: errorMessage,
    stackTrace: error?.stack || '',
    requestPayload: encryptedPayload,
  };
  const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/error/logging`;
  try {
    await axios.post(url, errorDetails);
   
     // If it's a ChunkLoadError, reload the application after logging
     if (isChunkLoadError) {
       errorDetails.reloadInitiated = true;
       logErrorToConsole('ChunkLoadError detected. Reloading application...');
       // Give the server a moment to process the log before reloading
       setTimeout(() => {
         window.location.reload();
       }, 500);
     }
  } catch (err) {
      logErrorToConsole('Error logging to backend:', err);
   
     // Still reload for ChunkLoadError even if logging fails
     if (isChunkLoadError) {
       logErrorToConsole('ChunkLoadError detected. Reloading application despite log failure...');
       setTimeout(() => {
         window.location.reload();
       }, 500);
     }
  }
}
